/**
 * "Connectivity With Level 0 Devices" — the Figma illustration (node 2251:56665)
 * is a flat bitmap, so the artwork is re-traced from that export into vector and
 * split into the parts that carry the story: the meter counts, the field device
 * broadcasts, and the pump exchanges readings with the plant.
 *
 * Geometry is the traced 635x125 export, 1:1, so the vector lands exactly where
 * the old PNG did.
 */
const ConnectivityArt = () => (
  <>
    <svg
      viewBox="0 0 635 125"
      fill="#F41E3D"
      role="img"
      aria-label="A field meter, a wireless Level 0 device and a pump exchanging readings"
      className="h-auto w-full"
    >
      <path d="M26.1 122.6C22.5 120.6 21.1 117.1 21 110.2L21 104L15 104C11.8 104 7.9 103.5 6.5 102.8C1.1 100.3 1 99.8 1 52C1 3.4 1 3.2 7.1 1.1C11.2 -0.3 94.7 -0.4 98.4 1C99.8 1.5 101.7 3.1 102.7 4.7C104.4 7.2 104.5 10.8 104.5 52.7L104.5 98L101.7 100.7C99.3 103.1 98.1 103.5 91.5 103.8L84 104.2L84 111.1C84 116.8 83.6 118.3 81.6 120.7L79.2 123.5L53.8 123.7C34.1 123.9 28 123.7 26.1 122.6Z M77.8 118.4C79.7 117.1 80 116 80 109.4L80 102L52.5 102L25 102L25 108.5C25 114.2 25.3 115.4 27.5 117.5L29.9 120L52.7 120C71.8 120 75.9 119.7 77.8 118.4Z M98.1 98.1L100.5 96.2L100.5 52L100.5 7.8L98.1 5.9C95.9 4.1 93.6 4 53 4C11.3 4 10.2 4 7.6 6.1L5 8.1L5 52L5 95.9L7.6 97.9C10.2 100 11.3 100 53 100C93.6 100 95.9 99.9 98.1 98.1Z M13.5 90.7C13.2 90.1 13.1 72.2 13.2 51L13.5 12.5L51.9 12.2C79.4 12.1 90.7 12.3 91.6 13.1C93.5 14.7 93.7 88.9 91.8 90.8C90 92.6 14.1 92.5 13.5 90.7Z M90.5 52L90.5 14.5L53 14.5L15.5 14.5L15.2 51C15.1 71.1 15.2 88.1 15.5 88.8C15.8 89.8 23.9 90 53.2 89.8L90.5 89.5L90.5 52Z M26.2 49.8C24.8 48.4 24.5 33.3 25.8 31.2C26.5 30.3 32.6 30 53.1 30.2L79.5 30.5L79.5 40.5L79.5 50.5L53.5 50.8C34.1 51 27.1 50.7 26.2 49.8Z M77.8 40.2L78.1 32L52.8 32.2L27.5 32.5L27.2 39.4C27 43.2 27.1 46.9 27.4 47.7C27.9 48.8 32.5 49 52.7 48.8L77.5 48.5L77.8 40.2Z M32.2 64.3C32.5 62.6 34.2 62.5 53 62.5C70.6 62.5 73.5 62.7 73.5 64C73.5 65.3 70.4 65.5 52.7 65.8C33.2 66 31.9 65.9 32.2 64.3Z M38.5 73.9C37 71.5 40.1 70.9 53.1 71.2C64.2 71.5 66.5 71.8 66.5 73C66.5 74.2 64.2 74.5 52.8 74.8C43.6 75 38.9 74.7 38.5 73.9Z M301.2 109.4C300.4 109 300 106.7 300 102.9L300 97L290.5 97C281.7 97 280.7 96.8 278.5 94.5C276.2 92.3 276 91.3 276 82.5L276 73L270.1 73C263.1 73 263 72.9 263 62C263 51.1 263.1 51 270.1 51L276 51L276 41.5C276 32.7 276.2 31.7 278.5 29.5C280.7 27.2 281.7 27 290.5 27L300 27L300 21C300 13.9 300.2 13.8 313 14.2L321.5 14.5L321.8 20.8L322.1 27L331.4 27C339.3 27 341.1 27.3 343.4 29.1C345.9 31.1 346 31.5 346 41L346 50.9L352.2 51.2L358.5 51.5L358.5 62L358.5 72.5L352.2 72.8L346 73.1L346 82.6C346 91.3 345.8 92.3 343.5 94.5C341.3 96.8 340.3 97 331.6 97L322.1 97L321.8 103.2L321.5 109.5L312 109.7C306.8 109.8 301.9 109.6 301.2 109.4Z M318 100.5L318 95L311 95L304 95L304 100.5L304 106L311 106L318 106L318 100.5Z M340.8 91.8C342.5 90.1 342.5 33.9 340.8 32.2C339.9 31.3 331.9 31 310.8 31C283.4 31 282 31.1 281 32.9C280.4 34.1 280 45.3 280 62.4C280 86 280.2 90.1 281.6 91.4C282.9 92.8 287 93 311.4 93C332 93 339.9 92.7 340.8 91.8Z M278 62L278 55L272.5 55L267 55L267 62L267 69L272.5 69L278 69L278 62Z M355 62L355 55L349.5 55L344 55L344 62L344 69L349.5 69L355 69L355 62Z M318 23.5L318 18L311 18L304 18L304 23.5L304 29L311 29L318 29L318 23.5Z M513 88.5L513 55L516 55C518.8 55 519 54.8 519 51C519 47.2 519.2 47 522 47L525 47L525 30.2C525 13.8 525 13.5 522.8 12.5C519.9 11.2 517.6 6.5 518.4 3.4L519 1L546.8 1.2L574.5 1.5L574.8 5.8C575.1 9.6 574.8 10.2 572.1 11.8C569.8 13 569 14.2 569 16.2L569 19L579 19L589 19L589 22.8C589 25.4 589.6 26.9 591 27.8C593.2 29.2 593.7 33.9 591.8 35.8C590.3 37.3 585.7 37.3 584.2 35.8C582.3 33.9 582.8 29.2 585 27.8C586.2 27 587 25.4 587 23.8L587 21L578 21L569 21L569 34L569 47L572 47C574.8 47 575 47.2 575 51C575 54.6 575.2 55 577.5 55C579.6 55 580 55.5 580 57.9C580 60.7 580.3 60.9 584.2 61.2C588.1 61.5 588.5 61.8 588.8 64.2C589.1 66.8 589.5 67 593.6 67L598 67L598 58C598 49.3 597.9 49 595.7 49C594.5 49 592.9 49.9 592.2 51C590.8 53.2 586.1 53.7 584.2 51.8C581.3 48.9 584 43 588.1 43C589.1 43 590.9 43.9 592 45C593.1 46.1 595.3 47 597 47L600 47L600 57L600 67L602.8 67C604.9 67 607.3 65.2 613.3 59.2L621 51.5L621 42.2L621 33L616.7 33C613.6 33 612.2 33.5 611.2 35C608.6 39.2 602 36.8 602 31.6C602 27.4 609 25.4 611.2 29C612.2 30.6 613.6 31 617.7 31L623 31L623 41.7L623 52.5L615.8 59.7L608.6 67L615.2 67C621 67 621.9 66.7 622.5 65C623.4 62.1 627.4 59.8 630.7 60.2L633.5 60.5L633.8 88.8L634 117L630 117C626.8 117 625.7 116.5 623.8 114L621.6 111L605.3 111L589 111L589 113.5C589 115.8 588.6 116 584.5 116C580.2 116 580 116.1 580 119L580 122L546.5 122L513 122L513 88.5Z M577 88.5L577 58L546.5 58L516 58L516 88.5L516 119L546.5 119L577 119L577 88.5Z M585.5 88.5L585.5 64L582.2 64L579 64L579 88.5L579 113L582.2 113L585.5 113L585.5 88.5Z M630 88.5C630 75 629.8 64 629.6 64C629.3 64 628.4 64.7 627.6 65.6C626.2 66.9 626 70.4 626 88.1C626 108.1 626.6 113 629 113C629.6 113 630 103.6 630 88.5Z M624 89L624 71L605.5 71L587 71L587 89L587 107L605.5 107L624 107L624 89Z M572 53L572 50L547 50L522 50L522 53L522 56L547 56L572 56L572 53Z M590.7 49.4C591 48.6 590.5 47.1 589.6 46.2C588.1 44.7 587.9 44.7 586.4 46.2C584.3 48.3 585.3 51 588 51C589.1 51 590.3 50.3 590.7 49.4Z M565 29.5L565 11L547 11L529 11L529 29.5L529 48L547 48L565 48L565 29.5Z M590 33.4C591.1 32.2 591 31.6 589.7 30.2C588.1 28.7 587.9 28.7 586.3 30.2C585 31.6 584.9 32.2 586 33.4C586.7 34.3 587.6 35 588 35C588.4 35 589.3 34.3 590 33.4Z M609.8 32.2C610.2 29.4 607.4 28.2 605.3 30.3C603.9 31.6 603.9 32.2 605 33.5C606.8 35.7 609.4 35 609.8 32.2Z M570.8 6.8C571.1 5.1 569.4 5 546.5 5C522.2 5 521.9 5 523 7C524.1 9 524.9 9 547.3 8.8C568.5 8.5 570.5 8.3 570.8 6.8Z" />
      <path
        className="ot-conn-digit"
        style={{ animationDelay: "0.00s" }}
        d="M34.4 43.7C33.4 41 34.4 36.5 36 36.5C37.1 36.5 37.5 37.6 37.5 40.4C37.5 44.4 35.5 46.5 34.4 43.7Z"
      />
      <path
        className="ot-conn-digit"
        style={{ animationDelay: "0.12s" }}
        d="M42.4 43.7C41.4 41 42.4 36.5 44 36.5C45.1 36.5 45.5 37.6 45.5 40.4C45.5 44.4 43.5 46.5 42.4 43.7Z"
      />
      <path
        className="ot-conn-digit"
        style={{ animationDelay: "0.24s" }}
        d="M51.4 43.7C50.4 41 51.4 36.5 53 36.5C54.1 36.5 54.5 37.6 54.5 40.4C54.5 44.4 52.5 46.5 51.4 43.7Z"
      />
      <path
        className="ot-conn-digit"
        style={{ animationDelay: "0.36s" }}
        d="M59.4 43.7C58.4 41 59.4 36.5 61 36.5C62.1 36.5 62.5 37.6 62.5 40.4C62.5 44.4 60.5 46.5 59.4 43.7Z"
      />
      <path
        className="ot-conn-digit"
        style={{ animationDelay: "0.48s" }}
        d="M68.4 43.7C67.4 41 68.4 36.5 70 36.5C71.1 36.5 71.5 37.6 71.5 40.4C71.5 44.4 69.5 46.5 68.4 43.7Z"
      />
      <path
        className="ot-conn-led"
        d="M49.2 113.8C46.4 111 48.5 106 52.6 106C55.5 106 57.2 108.3 56.8 111.7C56.6 114 56 114.6 53.5 114.8C51.8 115 49.9 114.5 49.2 113.8Z M54.7 111.4C55 110.6 54.8 109.4 54.1 108.7C52.7 107.3 49.4 110.2 50.4 111.9C51.4 113.5 54 113.2 54.7 111.4Z"
      />
      <path
        className="ot-conn-wave-l"
        style={{ animationDelay: "0.00s" }}
        d="M249.1 73.4C244.4 67.5 244.1 58.1 248.4 51.8C250.6 48.4 254 46.8 254 49.2C254 49.9 252.9 52.7 251.5 55.4C250.1 58.1 249 61.1 249 62C249 62.9 250.1 65.9 251.5 68.6C252.9 71.3 254 74.1 254 74.8C254 76.9 251.2 76.1 249.1 73.4Z"
      />
      <path
        className="ot-conn-wave-l"
        style={{ animationDelay: "0.18s" }}
        d="M240.3 82.2C235 75 233.6 70.8 233.6 62C233.6 55 234 52.7 235.9 49C239.4 42.3 242.2 39 244.2 39C246.9 39 246.4 41.5 242.6 46.5C237.9 52.6 236.3 60.1 237.9 67.5C238.7 70.8 240.5 74.8 242.6 77.5C244.5 80 246 82.7 246 83.5C246 86 242.5 85.2 240.3 82.2Z"
      />
      <path
        className="ot-conn-wave-l"
        style={{ animationDelay: "0.36s" }}
        d="M230.8 90.2C228.9 88.1 226 83.7 224.4 80.4C221.7 74.8 221.5 73.8 221.5 62C221.5 50.6 221.7 49 224.1 43.9C227 37.7 233.4 30 235.6 30C238 30 237.2 33.1 233.9 36.8C232.1 38.8 229.5 42.9 228.1 46C225.8 50.8 225.5 52.8 225.5 62C225.5 71.2 225.8 73.2 228.1 78C229.5 81.1 232.1 85.2 233.9 87.2C237.2 90.9 238 94 235.6 94C234.9 94 232.7 92.3 230.8 90.2Z"
      />
      <path
        className="ot-conn-wave-r"
        style={{ animationDelay: "0.00s" }}
        d="M368 74.5C368 73.6 369 71.5 370.2 69.9C371.9 67.7 372.5 65.4 372.5 62C372.5 58.6 371.9 56.3 370.2 54.1C367.6 50.5 367.4 48 369.8 48C372.1 48.1 374.7 51.8 376.2 57.4C377.6 62.6 376.3 69.3 373.2 73.6C371.3 76.2 368 76.8 368 74.5Z"
      />
      <path
        className="ot-conn-wave-r"
        style={{ animationDelay: "0.18s" }}
        d="M376 83.6C376 82.8 377.1 80.9 378.4 79.3C382.1 74.8 384.1 70.2 384.7 64.6C385.4 58 383.8 52.4 379.5 46.1C375.5 40.3 375.2 39 377.9 39C380.5 39 385.7 46.3 387.5 52.4C390.4 62.2 388.7 72.9 382.9 80.8C379.9 84.9 376 86.5 376 83.6Z"
      />
      <path
        className="ot-conn-wave-r"
        style={{ animationDelay: "0.36s" }}
        d="M385 92.4C385 91.5 386.4 89.2 388 87.3C395.4 78.9 398.9 66.5 397 55.8C395.7 48.7 392.3 41.6 388 36.7C384.5 32.7 384.1 30 386.9 30C389.5 30 396.2 39.4 399.1 46.9C400.8 51.2 401.3 54.7 401.3 62C401.3 73.2 399.3 79.5 392.9 88.4C388.9 93.9 385 95.9 385 92.4Z"
      />
      <path
        className="ot-conn-core"
        d="M302 82C302 79.4 301.6 79 299.2 79C295.6 79 294 77.4 294 73.8C294 71.4 293.6 71 291 71C289.4 71 288 70.5 288 70C288 69.5 289.4 69 291 69C293.7 69 294 68.7 294 66C294 63.3 293.7 63 291 63C289.4 63 288 62.5 288 62C288 61.5 289.4 61 291 61C293.7 61 294 60.7 294 58C294 55.3 293.7 55 291 55C289.4 55 288 54.5 288 54C288 53.5 289.4 53 291 53C293.6 53 294 52.6 294 50.2C294 46.6 295.6 45 299.2 45C301.6 45 302 44.6 302 42C302 40.4 302.4 39 303 39C303.6 39 304 40.4 304 42C304 44.7 304.3 45 307 45C309.7 45 310 44.7 310 42C310 40.4 310.4 39 311 39C311.6 39 312 40.4 312 42C312 44.7 312.3 45 315 45C317.7 45 318 44.7 318 42C318 40.4 318.4 39 319 39C319.6 39 320 40.3 320 41.9C320 44.6 320.3 44.9 323.8 45.2C327.3 45.5 327.5 45.7 327.8 49.3C328.1 52.7 328.4 53 331.1 53C332.7 53 334 53.5 334 54C334 54.5 332.6 55 331 55C328.3 55 328 55.3 328 58C328 60.7 328.3 61 331 61C332.6 61 334 61.5 334 62C334 62.5 332.6 63 331 63C328.3 63 328 63.3 328 66C328 68.7 328.3 69 331 69C332.6 69 334 69.5 334 70C334 70.5 332.6 71 331 71C328.3 71 328 71.3 328 74.4C328 78 326.8 79 322.4 79C320.4 79 320 79.5 320 82C320 83.7 319.6 85 319 85C318.4 85 318 83.7 318 82C318 79.3 317.7 79 315 79C312.3 79 312 79.3 312 82C312 83.7 311.6 85 311 85C310.4 85 310 83.7 310 82C310 79.3 309.7 79 307 79C304.3 79 304 79.3 304 82C304 83.7 303.6 85 303 85C302.4 85 302 83.7 302 82Z M325.5 62L325.5 47.5L311 47.5L296.5 47.5L296.2 60.9C296.1 68.3 296.2 75 296.4 75.7C296.8 76.8 300.1 77 311.2 76.8L325.5 76.5L325.5 62Z"
      />
      <path
        className="ot-conn-up"
        d="M538 30.3L538 24.7L535.7 26.8C533 29.3 532 29.6 532 27.7C532 25.9 537.2 21 539.1 21C540.6 21 547 26.9 547 28.3C547 29.7 544.6 28.9 542.3 26.8L540 24.7L540 30.3C540 33.4 539.5 36 539 36C538.5 36 538 33.4 538 30.3Z"
      />
      <path
        className="ot-conn-down"
        d="M551.7 36.2C547.4 31.7 548.3 29 552.7 33.2L555 35.3L555 29.2C555 25.7 555.4 23 556 23C556.6 23 557 25.7 557 29.2L557 35.3L559.3 33.2C563.5 29.3 564.5 30.9 560.5 35C558.4 37.2 556.1 39 555.5 39C554.9 39 553.2 37.7 551.7 36.2Z"
      />
      <path
        className="ot-conn-flow-r"
        d="M606 88.3C606 87.9 607.2 86.3 608.7 84.8L611.4 82L605.2 82C601.7 82 599 81.6 599 81C599 80.4 601.7 80 605.2 80L611.3 80L609.2 77.7C606.7 75.1 606.4 74 608.2 74C609.7 74 615 79 615 80.5C615 81.1 613.3 83.3 611.2 85.3C607.5 88.9 606 89.8 606 88.3Z"
      />
      <path
        className="ot-conn-flow-l"
        d="M599 101.5L595.6 98L599.5 94C603.6 89.8 605.9 90.3 601.9 94.6L599.7 97L605.8 97C609.3 97 612 97.4 612 98C612 98.5 609.4 99 606.3 99L600.7 99L602.8 101.3C604 102.6 605 103.9 605 104.3C605 106.1 602.1 104.7 599 101.5Z"
      />
      <path
        className="ot-conn-drop"
        d="M530.1 106.4C524.5 101.4 524.3 92.5 529.4 81.6C532.5 74.9 537.6 68 539.5 68C541.6 68 549.4 80.3 551.5 86.8C554 94.3 553.2 102.3 549.7 105.8C547.4 108 546 108.5 540.1 108.8C533.7 109.2 533.1 109 530.1 106.4Z M547.1 103.1C549.3 100.8 550 99.2 550 96.1C550 91.1 547.2 83.6 543 76.9C539.1 70.9 538.6 71.1 533 82.2C529.9 88.3 529 91.4 529 95.2C529 103.4 531.4 105.8 539.8 105.9C543.3 106 544.7 105.4 547.1 103.1Z"
      />
      <path
        className="ot-conn-drop"
        style={{ animationDelay: "0.6s" }}
        d="M556.2 77.8C553.1 74.7 557 62.5 561 62.5C562.8 62.5 567 69.7 567 72.8C567 77.1 565.2 79 561.2 79C559.1 79 556.9 78.5 556.2 77.8Z M563.5 75C564.3 73.7 562.1 67 560.9 67C559.8 67 558 71.3 558 74.1C558 75.4 558.7 76 560.4 76C561.8 76 563.2 75.5 563.5 75Z"
      />
      <circle
        className="ot-conn-node"
        cx="588"
        cy="31.9"
        r="2.1"
        style={{ animationDelay: "0.00s" }}
      />
      <circle
        className="ot-conn-node"
        cx="607"
        cy="32"
        r="2.1"
        style={{ animationDelay: "0.25s" }}
      />
      <circle
        className="ot-conn-node"
        cx="587.7"
        cy="47.9"
        r="2.1"
        style={{ animationDelay: "0.50s" }}
      />
    </svg>

    <style jsx>{`
      /* The meter's five digit wheels flip in turn, like a reading ticking over. */
      @keyframes otConnDigit {
        0%,
        55%,
        100% {
          transform: scaleY(1);
          opacity: 1;
        }
        25% {
          transform: scaleY(0.15);
          opacity: 0.45;
        }
      }
      :global(.ot-conn-digit) {
        transform-box: fill-box;
        transform-origin: center;
        animation: otConnDigit 2.4s ease-in-out infinite;
      }

      /* Status lamp on the meter's foot. */
      @keyframes otConnLed {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.2;
        }
      }
      :global(.ot-conn-led) {
        animation: otConnLed 1.9s ease-in-out infinite;
      }

      /* The three arcs on each side ripple away from the chip, innermost first,
         so the device reads as transmitting rather than merely decorated. */
      @keyframes otConnWaveL {
        0%,
        100% {
          opacity: 0.35;
          transform: translateX(3px);
        }
        35% {
          opacity: 1;
          transform: translateX(0);
        }
      }
      @keyframes otConnWaveR {
        0%,
        100% {
          opacity: 0.35;
          transform: translateX(-3px);
        }
        35% {
          opacity: 1;
          transform: translateX(0);
        }
      }
      :global(.ot-conn-wave-l) {
        animation: otConnWaveL 2.1s ease-in-out infinite;
      }
      :global(.ot-conn-wave-r) {
        animation: otConnWaveR 2.1s ease-in-out infinite;
      }

      /* Chip core breathes on the same period as the waves it feeds. */
      @keyframes otConnCore {
        0%,
        100% {
          opacity: 0.7;
        }
        35% {
          opacity: 1;
        }
      }
      :global(.ot-conn-core) {
        animation: otConnCore 2.1s ease-in-out infinite;
      }

      /* Tank arrows alternate: level up, level down. */
      @keyframes otConnUp {
        0%,
        100% {
          opacity: 0.6;
          transform: translateY(2px);
        }
        40% {
          opacity: 1;
          transform: translateY(-1px);
        }
      }
      @keyframes otConnDown {
        0%,
        100% {
          opacity: 0.6;
          transform: translateY(-2px);
        }
        40% {
          opacity: 1;
          transform: translateY(1px);
        }
      }
      :global(.ot-conn-up) {
        animation: otConnUp 2.4s ease-in-out infinite;
      }
      :global(.ot-conn-down) {
        animation: otConnDown 2.4s ease-in-out infinite 1.2s;
      }

      /* Valve flow: each arrow nudges along its own direction, out of phase. */
      @keyframes otConnFlowR {
        0%,
        100% {
          opacity: 0.6;
          transform: translateX(-3px);
        }
        45% {
          opacity: 1;
          transform: translateX(3px);
        }
      }
      @keyframes otConnFlowL {
        0%,
        100% {
          opacity: 0.6;
          transform: translateX(3px);
        }
        45% {
          opacity: 1;
          transform: translateX(-3px);
        }
      }
      :global(.ot-conn-flow-r) {
        animation: otConnFlowR 2.2s ease-in-out infinite;
      }
      :global(.ot-conn-flow-l) {
        animation: otConnFlowL 2.2s ease-in-out infinite 1.1s;
      }

      @keyframes otConnDrop {
        0%,
        100% {
          opacity: 0.75;
          transform: scale(1);
        }
        50% {
          opacity: 1;
          transform: scale(1.06);
        }
      }
      :global(.ot-conn-drop) {
        transform-box: fill-box;
        transform-origin: center;
        animation: otConnDrop 3s ease-in-out infinite;
      }

      /* The sensor eyes on the signal wires light up down the chain. */
      @keyframes otConnNode {
        0%,
        70%,
        100% {
          opacity: 0;
        }
        15%,
        45% {
          opacity: 1;
        }
      }
      :global(.ot-conn-node) {
        opacity: 0;
        animation: otConnNode 1.8s ease-in-out infinite;
      }

      @media (prefers-reduced-motion: reduce) {
        :global(.ot-conn-digit),
        :global(.ot-conn-led),
        :global(.ot-conn-wave-l),
        :global(.ot-conn-wave-r),
        :global(.ot-conn-core),
        :global(.ot-conn-up),
        :global(.ot-conn-down),
        :global(.ot-conn-flow-r),
        :global(.ot-conn-flow-l),
        :global(.ot-conn-drop) {
          animation: none;
        }
        /* The eyes are drawn on top of the artwork, so hide rather than freeze. */
        :global(.ot-conn-node) {
          animation: none;
          opacity: 0;
        }
      }
    `}</style>
  </>
);

export default ConnectivityArt;
